import { Box, Flex } from "@chakra-ui/layout";
import { SelectProps } from "antd";
import useGetBancos from "core/features/banco/hooks/useGetBancos";
import colors from "core/resources/theme/colors";
import { useState } from "react";
import { MdAccountBalance } from "react-icons/md";
import SelectBaseAntd from "../SelectBaseAntd";

export interface SelectBancoProps<T = any> extends SelectProps<T> {
  value: any;
  onChange: (v: any, item: any) => void;
  isInvalid?: boolean;
}

function SelectBanco({
  value,
  onChange,
  isInvalid,
  ...rest
}: SelectBancoProps) {
  const { isFetching, data } = useGetBancos();
  const [search, setSearch] = useState<string>();

  const handleChange = (v: string) => {
    const item = data?.find((item) => item.id === v);

    onChange(v, item);
  };

  return (
    <>
      <SelectBaseAntd
        isInvalid={isInvalid}
        loading={isFetching}
        size="large"
        placeholder="Banco"
        value={value}
        onChange={handleChange}
        {...rest}
        showSearch
        disabled={isFetching || rest.disabled}
        searchValue={search}
        onSearch={setSearch}
        optionFilterProp="extra"
        options={data?.map((item: any) => ({
          value: item.id,
          extra: `${item.codigo} - ${item.nome}`,
          label: (
            <Flex alignItems="center">
              <Flex mr="4px">
                {item.imagemUrl ? (
                  <img
                    src={item.imagemUrl}
                    style={{
                      width: "28px",
                      height: "28px",
                      borderRadius: "4px",
                    }}
                    alt={`Logo ${item.nome}`}
                  />
                ) : (
                  <Flex
                    w="28px"
                    h="28px"
                    rounded="4px"
                    bg="gray.100"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <MdAccountBalance color={colors.black700} />
                  </Flex>
                )}
              </Flex>
              <Flex w="30px">{item.codigo}</Flex>
              <Flex flex={1} alignItems="center">
                - {item.nome}
              </Flex>
            </Flex>
          ),
        }))}
        notFoundContent={<Box>Nenhum banco encontrado</Box>}
      />
    </>
  );
}

export default SelectBanco;
